module.exports = __webpack_public_path__ + "img/question.87694621.png";